import { GenealogyModal } from "@common/components/Diagram/Genealogy/component";
import { type GenealogyItem } from "@common/components/Diagram/Genealogy/lib";
import OrganizationalDiagram from "@common/controls/Diagram/Basicprimitives/Organizational/component";
import { Basicprimitives } from "@common/controls/Diagram/Basicprimitives/types";
import { type GenericMap } from "@common/declarations";
import React from "react";
import { type ReportGetItemDetail } from "../types";
import { getConfig } from "./lib";

import "./style.less";

export type DiagramConfig = Partial<Basicprimitives.OrgDiagramConfig<any>> & {
  totalRecords?: number;
};

export interface DiagramReportProps {
  data?: any[];
  config: DiagramConfig;
  getItemDetail?: ReportGetItemDetail;
  parameters: GenericMap<any>;
}

const DiagramReport = (props: DiagramReportProps) => {
  const [item, setItem] = React.useState<Basicprimitives.OrgItemConfig | null>(null);
  const onItemClick = React.useCallback((item: any) => setItem(item), [setItem]);
  const config = React.useMemo(
    () => getConfig(props.config, props.data || [], onItemClick),
    [props.config, props.data, onItemClick]
  );
  const exit = React.useCallback(() => setItem(null), [setItem]);

  return (
    <>
      <OrganizationalDiagram config={config} />

      {item?.templateName === "genealogy" && props.getItemDetail && (
        <GenealogyModal
          item={item as GenealogyItem}
          parameters={props.parameters}
          exit={exit}
          getDetail={props.getItemDetail["genealogy"]}
        />
      )}
    </>
  );
};
export default DiagramReport;
